import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="uploads3file">
                1.&nbsp;<span className="material-symbols-outlined">upload</span>&nbsp;{translate('uploads3file')}
            </Typography>
            <p><strong>{translate('uploads3file')}</strong> là một hành động tải tệp lên AWS S3.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$uploadS3File_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối AWS S3. (xem <Box component={Link} to="/control-center/documentation/connections/awss3">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp muốn tải lên.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('bucketname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của bucket AWS sẽ lưu tệp tải lên.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$uploadS3File_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>awss3-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "ETag":'"2f502d2ca56c9086d63822e67762b4df\"',
                                            "ServerSideEncryption":"AES256",
                                            "VersionId":"B2q.NP_e44vGf_vliD46Iib2Mey4LopG",
                                            "Location":"https://data-all.s3.amazonaws.com/test/combine.pdf",
                                            "key":"test/combine.pdf",
                                            "Key":"test/combine.pdf",
                                            "Bucket":"data-test"
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="downloads3file">
                2.&nbsp;<span className="material-symbols-outlined">download</span>&nbsp;{translate('downloads3file')}
            </Typography>
            <p><strong>{translate('downloads3file')}</strong> là một hành động tải xuống tệp từ AWS S3.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$downloadS3File_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối AWS S3. (xem <Box component={Link} to="/control-center/documentation/connections/awss3">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('bucketname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của  bucket AWS lưu tệp cần tải xuống.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên tệp muốn tải xuống.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$downloadS3File_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>awss3-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('bucketname')}</span>
                            <div>data-test</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>combine.pdf</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);